import { Config } from "../../../config/config";
import { useDataFetch } from "../../hooks/useDataFetch";
import { useSocket } from "../../hooks/useSocket";
import { useAppState } from "../contextProvider";
import { AppActions } from "../reducers";

export const useConfig = () => {
  const { updateStore, config } = useAppState();
  const { callAPI } = useDataFetch();
  const { connect } = useSocket();

  async function updateLoginSuccess(refillConfig = true, userDetails, _serverValue = null) {
    updateStore({
      type: AppActions.AddSession,
      payload: { userDetails, isValidSession: true },
    });

    // Student UI: use single configured API base URL (initialState / .env) for all endpoints.
    // Do not overwrite API_BASE_URL with server from backend.

    let configs;
    if (refillConfig) {
      configs = await callAPI(Config.ITradeAPI.getConfig, {}, {}, "POST", false, null);
      if (configs?.data) localStorage.setItem("configs", JSON.stringify(configs.data));
    } else {
      const stored = localStorage.getItem("configs");
      configs = stored ? { data: JSON.parse(stored) } : null;
      if (!configs?.data) {
        configs = await callAPI(Config.ITradeAPI.getConfig, {}, {}, "POST", false, null);
        if (configs?.data) localStorage.setItem("configs", JSON.stringify(configs.data));
      }
    }

    updateStore({
      type: AppActions.AddConfig,
      payload: configs?.data || configs || {},
    });
    connect(userDetails?.profileID);
  }

  function getLookupValues(lookupName) {
    const lookup = config?.lookup;
    if (Array.isArray(lookup)) {
      const item = lookup.find((l) => l.lookupKey === lookupName);
      if (item?.lookupValues) return item.lookupValues;
    }
    if (lookupName === "Algorithms") return [{ key: "SMAPC", value: "SMAPC" }];
    if (lookupName === "TradingMode") return [{ key: "R", value: "Rule" }, { key: "AI", value: "AI" }];
    if (lookupName === "TradingType") return [{ key: "B", value: "Buy Only" }, { key: "S", value: "Buy And Sell" }];
    if (lookupName === "RunProcessType") return [{ key: "Instant", value: "Instant" }, { key: "Scheduled", value: "Scheduled" }];
    return null;
  }

  function getInstrumentsOptions() {
    const instruments = config?.instruments;
    if (!Array.isArray(instruments)) return [];
    return instruments.map((i) => ({ key: i.token, value: i.name }));
  }

  /** Tokens on the algorithm's HotTokens list (synced from Core.API with the config), as strings. */
  function getHotTokens(algoKey) {
    // Own-table algorithms and IN.Core TrendData ones (e.g. SR) both carry their hot tokens.
    const algo = [...(config?.algorithms || []), ...(config?.trendAlgorithms || [])].find((a) => a.algoKey === algoKey);
    return new Set((algo?.hotTokens || []).map((t) => String(t)));
  }

  return { getLookupValues, updateLoginSuccess, getInstrumentsOptions, getHotTokens };
};
